import { mergeSxProps } from "@clipboard-health/ui-components";
import { getSafeAreaPaddings } from "@clipboard-health/ui-theme";
import { Box, type BoxProps, Fade } from "@mui/material";

import { getInsightBackground } from "./Insight/getInsightBackground";
import { type InsightWrapperVariant } from "./Insight/types";

export interface AnimatedInsightWrapperProps extends Omit<BoxProps, "component"> {
  insightType: InsightWrapperVariant;
  visible: boolean;
  onClick?: () => void;
}

export function AnimatedInsightWrapper(props: AnimatedInsightWrapperProps) {
  const { insightType, visible, sx, children, onClick, ...rest } = props;

  return (
    <Fade
      mountOnEnter
      unmountOnExit
      in={visible}
      appear={false}
      timeout={{ appear: 1000, enter: 1000, exit: 200 }}
    >
      <Box
        id={insightType}
        sx={mergeSxProps(
          (theme) => ({
            background: getInsightBackground(insightType),
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "stretch",
            position: "absolute",
            inset: 0,
            ...getSafeAreaPaddings({
              top: true,
              fallbackTop: theme.spacing(3),
            }),
          }),
          sx
        )}
        onClick={onClick}
        {...rest}
      >
        {/* to composate height of the absolute header */}
        <Box sx={(theme) => ({ height: theme.size?.button.small })} />

        {children}
      </Box>
    </Fade>
  );
}
